import classNames from "classnames";
import { useTranslation } from "features/translations";
import React, { useMemo } from "react";
import {
  Container,
  Heading3,
  Icon,
  PageLink,
  Paragraph,
  SwiperLayout,
} from "shared/components";
import { SwiperSlide } from "swiper/react";

import { Item } from "../Item";
import styles from "./SliderView.module.scss";

export const SliderView = ({ title, articles }) => {
  const { t } = useTranslation();
  const prevRef = React.useRef(null);
  const nextRef = React.useRef(null);

  const items = useMemo(() => articles, [articles]);

  return (
    <>
      <Container className={styles.inner}>
        <div className={styles.header}>
          <Heading3 className={styles.title}>{title}</Heading3>
          <div className={styles["navigation-wrapper"]}>
            <div className={styles["slider-navigation"]}>
              <div
                ref={prevRef}
                className={classNames(
                  styles.navigation,
                  styles["navigation-prev"]
                )}
              >
                <Icon className={styles.icon} name="arrow_slider_prev" />
              </div>
              <div
                ref={nextRef}
                className={classNames(
                  styles.navigation,
                  styles["navigation-next"]
                )}
              >
                <Icon className={styles.icon} name="arrow_slider_next" />
              </div>
            </div>
          </div>
        </div>
      </Container>
      <div className={styles.slider}>
        <SwiperLayout
          prevRef={prevRef}
          nextRef={nextRef}
          watchOverflow={true}
          slidesPerView={"auto"}
          spaceBetween={4}
          slidesPerGroup={1}
          slidesOffsetAfter={30}
        >
          {items.map((item) => (
            <SwiperSlide key={item.id} className={styles.slide}>
              <Item className={styles.item} {...item} />
            </SwiperSlide>
          ))}
        </SwiperLayout>
      </div>
      <Container>
        <PageLink slug={"news"} className={styles.link}>
          <Paragraph className={styles.text} color="dark" uppercase>
            {t("showAllNews")}
          </Paragraph>
        </PageLink>
      </Container>
    </>
  );
};

export default SliderView;
